import MarketplaceItemProcessingTimeData from './MarketplaceItemProcessingTimeData'

export default MarketplaceItemProcessingTimeData
